import qs from 'qs';
import Util from '@/util';

const entityName = 'Стоматолог (Место работы)';
const serviceKey = 'employeeEmployments';
const serviceKeyRegShopEmployees = 'regShopEmployees';

const EmployeeEmployments = {
    namespaced: true,

    state: {
        items: [],
    },

    getters: {
        items(state) {
            return state.items;
        },
    },

    mutations: {
        setItems(state, { items }) {
            state['items'] = items;
        },
    },

    actions: {
        loadItems({ commit, dispatch, rootGetters }, requestParameters) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'requestParameters': Util.buildGetParams(requestParameters),
                        'token': rootGetters['auth/getToken'],
                        'service': rootGetters.service[serviceKey],
                    }),
                }).then(response => (
                    commit('setItems', {
                        items: response.data
                    }),  
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', `Список '${entityName}' получен`),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', `Ошибка при получении списка '${entityName}'`),
                    reject(err);
                });
            })
        },

        save({ dispatch, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': JSON.stringify(data.data),
                        'token': rootGetters['auth/getToken'],
                        'service': rootGetters.service[serviceKeyRegShopEmployees],
                    }),
                }).then(response => {
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit(
                        'APP_DATA_RECIEVE_SUCCESS',
                        data.index !== -1 ? 'Данные успешно отредактированы' : 'Запись создана'
                    );
                    resolve(response);
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root: true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных');
                        reject(err);
                });
            })
        },

        remove({ dispatch, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root: true});                

                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': JSON.stringify(data.item),
                        'token': rootGetters['auth/getToken'],
                        'service': rootGetters.service[serviceKeyRegShopEmployees],
                    }),
                }).then(response => (
                    dispatch('loading/isLoading', false, {root: true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Запись удалена'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root: true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении записи'),
                    reject(err);
                });
            })
        },
    },
};

export default EmployeeEmployments;


// WEBPACK FOOTER //
// ./src/store/modules/employeeEmployments.js